import Intro from '@/views/Intro.vue'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import UserProfile from '@/views/UserProfile.vue'
import api from '@/api';
import Unauthorized from '@/views/Unauthorized.vue'
import UserPricing from '@/views/Pricing.vue'
import NonLoginBusinessMatch from '@/views/NonLoginBusinessMatch.vue'
import NonLoginBusinessMatchContent from '@/views/NonLoginBusinessMatchContent.vue'
import NonLoginBusinessMatchResults from '@/views/NonLoginBusinessMatchResults.vue'
import BusinessMatchHome from '@/views/BusinessMatchHome.vue';
import BusinessMatchContent from '@/views/BusinessMatchContent.vue';
import BusinessMatchResults from '@/views/BusinessMatchResults.vue';
import BusinessMatchHistory from '@/views/BusinessMatchHistory.vue';
import BusinessMatchSavedContacts from '@/views/BusinessMatchSavedContacts.vue'
import BusinessMatchSharingMatchResults from '@/views/BusinessMatchSharingMatchResults.vue'
import NonLoginSharingMatchResults from '@/views/NonLoginSharingMatchResults.vue'
import BusinessMatchSharingProfile from '@/views/BusinessMatchSharingProfile.vue'
import NonLoginSharingProfile from '@/views/NonLoginSharingProfile.vue'
import BusinessMatchEmailSent from '@/views/BusinessMatchEmailSent.vue'
import ChatRoom from '@/views/ChatRoom.vue'
import NonLoginChatRoom from '@/views/NonLoginChatRoom.vue'
import store from '@/store/index'
import userManager from '@/user-manager';
import * as types from '@/store/mutation-types'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
	{
		path: '/',
		beforeEnter: (to, from, next) => {
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next({ path: '/nl-match' });
				} else {
					next({ path: '/match/home' });
				}
				next();
			}).catch(err => {
				console.error(err);
				next();
			});
		}
	},
	{
		path: '/',
		name: 'Home',
		component: Home,
		beforeEnter: (to, from, next) => {
			localStorage.removeItem('TMP_USER_EMAIL')
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next({ path: '/nl-match' });
				} else {
					if (localStorage.getItem('TMP_USER_ID')) {
						const tmpUserId = localStorage.getItem('TMP_USER_ID') as string
						api.authApi.getMe()
							.then(resp => {
								store.commit(types.SIGNED_IN, { accessToken: user?.access_token, profile: user.profile, userDto: resp.data.data });

								api.businessMatchApi.migrateUsageRecords(store.state.user.userDto?.id as string, tmpUserId, store.state.track.trackDto?.id? store.state.track.trackDto.id : '0')
									.then(migrateUsageRecordsResp => {
										if (localStorage.getItem('LOGIN_TO_PAGE') == 'results') {
											next({ path: '/match/results' });
										} else if (localStorage.getItem('LOGIN_TO_PAGE') == 'content') {
											next({ path: '/match/content' });
										} else if (localStorage.getItem('LOGIN_TO_PAGE') == 'home') {
											next({ path: '/match/home' });
										} else if (localStorage.getItem('LOGIN_TO_PAGE') == 'sharing') {
											next({ path: '/match/sharing/' + localStorage.getItem('SHARING_REQUEST_ID') });
										} else if (localStorage.getItem('LOGIN_TO_PAGE') == 'chat') {
											next({ path: '/chat' });
										} else {
											next({ path: '/match/home' });
										}
										localStorage.removeItem('TMP_USER_ID')
										localStorage.removeItem('LOGIN_TO_PAGE')
										localStorage.removeItem('SHARING_REQUEST_ID')
										next();
									})
									.catch(error => {
										localStorage.removeItem('TMP_USER_ID')
										localStorage.removeItem('LOGIN_TO_PAGE')
										localStorage.removeItem('SHARING_REQUEST_ID')
										console.error('Error migrating usage records:', error);
										next({ path: '/match/home' });
										next();
									});
							}, console.error)
							.catch(error => {
								localStorage.removeItem('TMP_USER_ID')
								localStorage.removeItem('LOGIN_TO_PAGE')
								localStorage.removeItem('SHARING_REQUEST_ID')
								localStorage.removeItem('SHARING_PROFILE_ID')
								console.error('Error get me:', error);
								next({ path: '/match/home' });
								next();
							});
					} else {
						api.authApi.getMe()
							.then(resp => {
								store.commit(types.SIGNED_IN, { accessToken: user?.access_token, profile: user.profile, userDto: resp.data.data });
								if (localStorage.getItem('LOGIN_TO_PAGE') == 'sharing') {
									next({ path: '/match/sharing/' + localStorage.getItem('SHARING_REQUEST_ID') });
								} else if (localStorage.getItem('LOGIN_TO_PAGE') == 'chat') {
									next({ path: '/chat' });
								}
								localStorage.removeItem('LOGIN_TO_PAGE')
								localStorage.removeItem('SHARING_REQUEST_ID')
								localStorage.removeItem('SHARING_PROFILE_ID')
								next();
							}, console.error)
					}
				}
			}, console.error);
		},
		children: [
			{
				path: "/pricing",
				name: "UserPricing",
				component: UserPricing
			},
			{
				path: "/profile",
				name: "UserProfile",
				component: UserProfile
			},
			{
				path: "/match/home",
				name: "BusinessMatchHome",
				component: BusinessMatchHome
			},
			{
				path: "/match/content",
				name: "BusinessMatchContent",
				component: BusinessMatchContent
			},
			{
				path: "/match/results",
				name: "BusinessMatchResults",
				component: BusinessMatchResults,
			},
			{
				path: "/match/email-sent",
				name: "BusinessMatchEmailSent",
				component: BusinessMatchEmailSent,
			},
			{
				path: "/match/sharing/:sharingRequestId",
				name: "BusinessMatchSharingMatchResults",
				component: BusinessMatchSharingMatchResults
			},
			{
				path: "/match/profile-sharing/:sharingProfileId",
				name: "BusinessMatchSharingProfile",
				component: BusinessMatchSharingProfile
			},
			{
				path: "/chat",
				name: "ChatRoom",
				component: ChatRoom
			},
			{
				path: "/match/my-contacts",
				name: "BusinessMatchSavedContacts",
				component: BusinessMatchSavedContacts,
			},
			{
				path: "/match/history",
				name: "BusinessMatchHistory",
				component: BusinessMatchHistory
			}
		]
	},
	{
		path: '/nl-match',
		name: 'NonLoginBusinessMatch',
		component: NonLoginBusinessMatch,
		beforeEnter: (to, from, next) => {
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next();
				} else {
					next({ path: '/match/results' });
					next();
				}
			}).catch(err => {
				console.error(err);
				next();
			});
		}
	},
	{
		path: "/nl-match/:tmpUserId/content",
		name: "NonLoginBusinessMatchContent",
		component: NonLoginBusinessMatchContent,
		beforeEnter: (to, from, next) => {
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next();
				} else {
					next({ path: '/match/content' });
					next();
				}
			}).catch(err => {
				console.error(err);
				next();
			});
		}
	},
	{
		path: "/nl-match/:tmpUserId/results",
		name: "NonLoginBusinessMatchResults",
		component: NonLoginBusinessMatchResults,
		beforeEnter: (to, from, next) => {
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next();
				} else {
					next({ path: '/match/results' });
					next();
				}
			}).catch(err => {
				console.error(err);
				next();
			});
		}
	},
	// {
	// 	path: "/match/sharing/:sharingRequestId",
	// 	name: "BusinessMatchSharingMatchResults",
	// 	component: BusinessMatchSharingMatchResults
	// },
	{
		path: "/nl-match/sharing/:sharingRequestId",
		name: "NonLoginSharingMatchResults",
		component: NonLoginSharingMatchResults
	},
	{
		path: "/nl-match/profile-sharing/:sharingProfileId",
		name: "NonLoginSharingProfile",
		component: NonLoginSharingProfile
	},
	{
		path: "/nl-chat/:chatTargetUserId?",
		name: "NonLoginChatRoom",
		component: NonLoginChatRoom,
		beforeEnter: (to, from, next) => {
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next();
				} else {
					next({ path: '/chat' });
				}
			}).catch(err => {
				console.error(err);
				next();
			});
		}
	},
	{
		path: '/unauthorized',
		name: 'Unauthorized',
		component: Unauthorized
	},
	{ path: '/intro', name: 'Intro', component: Intro },
	{ path: '/intro/:publicId', name: 'IntroRequest', component: Intro },
	{
		path: '*',
		beforeEnter: (to, from, next) => {
			userManager.getUser().then(user => {
				if (!user || user.expired) {
					next({ path: '/nl-match' });
				} else {
					next({ path: '/match/results' });
				}
				next();
			}).catch(err => {
				console.error(err);
				next();
			});
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach(async (to, from, next) => {
 if (to.path === '/intro' || to.path.startsWith('/intro/')) {
  const w = window as any;
  if (w.amplitude?.setOptOut) w.amplitude.setOptOut(true);
  if (w.sessionReplay?.stop) w.sessionReplay.stop();
  if (w.posthog?.opt_out_capturing) w.posthog.opt_out_capturing();
  w['ga-disable-' + process.env.VUE_APP_GA_TAG_ID] = true;
  w['ga-disable-G-2P4LFW2ME8'] = true;
  next(); return;
 }

	// window.addEventListener("message", (e) => {
	// 	if (e.origin === "https://www.namecard.ai") {
	// 		localStorage.setItem("TMP_USER_EMAIL", e.data.tmpUserId as string);
	// 		console.log("Token received:", e.data.tmpUserId);
	// 	}
	// });

	const params = new URLSearchParams(window.location.hash.substring(1));
	const token = params.get("tmpUserEmail");
	if (token) {
		localStorage.setItem("TMP_USER_EMAIL", token);
	}

	let currentParsedUrl = location.href
	let baseUrl = process.env.VUE_APP_BASE_URL;
	let baseDomain = process.env.VUE_APP_BASE_DOMAIN;

	if(location.href.includes('localhost')){
		currentParsedUrl = 'https://ifa.ws.dev.namecard.ai/match'
		baseUrl = 'https://ws.dev.namecard.ai';
		baseDomain = '.ws.dev.namecard.ai';
	}

	const baseDomainIndex = currentParsedUrl.indexOf(baseDomain);
	const baseLine = currentParsedUrl.indexOf('//');

	if (baseDomainIndex > -1 && !currentParsedUrl.includes(baseUrl)) {
		const baseDomainPrefix = currentParsedUrl.substring(baseLine + 2, baseDomainIndex);

		// 當 baseDomainPrefix 為 'bni' 時，API 失敗也不跳轉
		if (baseDomainPrefix === 'bni') {
			// next();
			return;
		}
		
		try {
			const productTrackResp = await api.productTrackApi.getProductTrack(baseDomainPrefix);
			store.commit('updateTrackDto', { trackDto: productTrackResp.data.data })
			next()
		} catch (error) {
			console.error('getProductTrack failed:', error);
			
			// Redirect to base URL home page
			const redirectUrl = baseUrl;
			window.location.href = redirectUrl;
			return;
		}
	}else{
		try {
			const productTrackResp = await api.productTrackApi.getProductTrack('all');
			store.commit('updateTrackDto', { trackDto: productTrackResp.data.data })
			next();
		} catch (error) {
			console.error('getProductTrack(all) failed:', error);
			window.location.href = baseUrl;
			return;
		}
		// next();
	}
})

export default router
